<template>
  <div
    class="text-[10px] font-mono flex items-center gap-4 text-light-disabled-text dark:text-dark-disabled-text"
  >
    <span>
      Gateway:
      <span :class="statusColor(readoutState.status)">{{
        readoutState.status
      }}</span>
      ({{ gatewayDeviceCount }}, last:
      {{ lastGatewayEvent ? formatRelative(lastGatewayEvent) : '—' }})
    </span>
    <span>
      Direct:
      <span :class="statusColor(deviceReadoutState.status)">{{
        deviceReadoutState.status
      }}</span>
      ({{ directDeviceCount }}, last:
      {{ lastDirectEvent ? formatRelative(lastDirectEvent) : '—' }})
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue';
import type {
  DeviceReadoutState,
  GatewayReadoutState,
} from '@/composables/useQToolOperations';
import { timeAgo } from '@/helpers/timeAgo';

const props = defineProps<{
  readoutState: GatewayReadoutState;
  deviceReadoutState: DeviceReadoutState;
}>();

function statusColor(status: string): string {
  if (status === 'reading') return 'text-green-500';
  if (status === 'done') return 'text-blue-500';
  if (status === 'error') return 'text-red-500';
  return '';
}

const gatewayDeviceCount = computed(() =>
  'devices' in props.readoutState
    ? (props.readoutState.devices?.length ?? 0)
    : 0
);
const directDeviceCount = computed(() =>
  'devices' in props.deviceReadoutState
    ? (props.deviceReadoutState.devices?.length ?? 0)
    : 0
);

const lastGatewayEvent = computed<number | null>(() => {
  if (!('devices' in props.readoutState) || !props.readoutState.devices)
    return null;
  let max: number | null = null;
  for (const d of props.readoutState.devices) {
    if (d.timestamp != null && (max == null || d.timestamp > max))
      max = d.timestamp;
  }
  return max;
});
const lastDirectEvent = computed<number | null>(() => {
  if (
    !('devices' in props.deviceReadoutState) ||
    !props.deviceReadoutState.devices
  )
    return null;
  let max: number | null = null;
  for (const d of props.deviceReadoutState.devices) {
    if (d.timestamp != null && (max == null || d.timestamp > max))
      max = d.timestamp;
  }
  return max;
});

const nowTick = ref(Date.now());
let nowTickTimer: ReturnType<typeof setInterval> | null = null;
onMounted(() => {
  nowTickTimer = setInterval(() => {
    nowTick.value = Date.now();
  }, 1000);
});
onUnmounted(() => {
  if (nowTickTimer) {
    clearInterval(nowTickTimer);
    nowTickTimer = null;
  }
});

function formatRelative(ts: number): string {
  void nowTick.value;
  return timeAgo(new Date(ts));
}
</script>
